
export default {
    data() {
        return {
            category: {
                list: ['特码', '合肖', '正码', '正码特', '一肖尾数', '连码', '自选不中', '连尾', '全部'],
                totle: {},
                active: '特码'
            }
        }
    },
    computed: {
        Base() {
            if (this.$store.state.base.options) {
                return this.$store.state.base.options
            }
            return {}
        },
        ZodiacList() {
            let zodiac = {}
            let dir = this.Base.chinese_zodiac.split(',').reverse()
            for (let i=1;i<=12;i++) {
                zodiac[i] = dir[i-1]
            }
            return zodiac
        },
        QuickBetList() {
            let list = {
                '大': [], '小': [], '单': [], '双': [],
                '大单': [], '小单': [], '合单': [], '大双': [], '小双': [], '合双': [],
                '家禽': [], '走兽': [], '野兽': [],
                '红波': [], '蓝波': [], '绿波': [],
                '尾单': [], '尾双': [], '尾大': [], '尾小': [], '特尾大': [], '特尾小': [], '合尾大': [], '合尾小': [],
                '金': [], '木': [], '水': [], '火': [], '土': [],
                '阴肖':[],'阳肖':[], '大单':[], '小单':[], '大双':[], '小双':[],
                '天肖':[],'地肖':[],'女肖':[],'男肖':[],'单笔':[],'双笔':[],
            }

            let zodiac = this.CodeZodiac()
            let color = this.CodeColor()
            for (let code=1;code<=49;code++) {

                // 数字类型
                if (code != 49) {
                    code >= 25 ? list['大'].push(code) : list['小'].push(code)
                    if(code >= 25 && code % 2 == 1){
                        list['大单'].push(code)
                    }else if(code >= 25 && code % 2 == 0){
                        list['大双'].push(code)
                    }
                    if(code < 25 && code % 2 == 1){
                        list['小单'].push(code)
                    }else if(code < 25 && code % 2 == 0){
                        list['小双'].push(code)
                    }
                    code % 2 == 1 ? list['单'].push(code) : list['双'].push(code)
                    

                    let merge = 0;
                    for (let num of `${code}`) {
                        merge+=Number(num)
                    }
                    merge % 2 == 1 ? list['合单'].push(code) : list['合双'].push(code)
                }
                // 生肖
                let zc = zodiac[code]
                if (!list[zc]) {
                    list[zc] = []
                }
                list[zc].push(code)
                zc=='马'||zc=='牛'||zc=='羊'||zc=='鸡'||zc=='狗'||zc=='猪' ? list['家禽'].push(code) : list['走兽'].push(code)

                // 颜色
                let cc = {'red': '红波', 'blue': '蓝波', 'green': '绿波'}[color[code]]
                list[cc].push(code)

                // 尾
                let tail = parseInt(code % 10)
                if (!list[`${tail}尾`]) {
                    list[`${tail}尾`] = []
                }
                list[`${tail}尾`].push(code)
                // 头
                let head = code < 10 ? '0' : `${code}`[0]
                if (!list[`${head}头`]) {
                    list[`${head}头`] = []
                }
                list[`${head}头`].push(code)


                //  尾大小
                if (code != 49) {
                    if (code<10) {
                        code % 2 == 1 ? list['尾单'].push(code) : list['尾双'].push(code)
                    } else {
                        let tail = code % 10
                        tail % 2 == 1 ? list['尾单'].push(code) : list['尾双'].push(code)
                    }

                    if (code<10) {
                        code >= 5 ? list['尾大'].push(code) : list['尾小'].push(code)
                        code >= 5 ? list['特尾大'].push(code) : list['特尾小'].push(code)
                    } else {
                        let tail = code % 10
                        tail >= 5 && tail < 10 ? list['尾大'].push(code) : list['尾小'].push(code)
                        tail >= 5 && tail < 10 ? list['特尾大'].push(code) : list['特尾小'].push(code)
                    }
                }
                if (code != 25) {
                    if (code<10) {
                        code >= 5 ? list['合尾大'].push(code) : list['合尾小'].push(code)
                    } else {
                        let tail = (Number(`${code}`[0]) + Number(`${code}`[1])) % 10
                        tail >= 5 && tail <= 9 ? list['合尾大'].push(code) : list['合尾小'].push(code)
                    }
                }
            }

            for (let item of ['红', '蓝', '绿']) {
                list[`${item}大`] = []
                list[`${item}小`] = []
                list[`${item}单`] = []
                list[`${item}双`] = []
                for (let code of list[`${item}波`]) {
                    code >= 25 ? list[`${item}大`].push(code) : list[`${item}小`].push(code)
                    code % 2 == 1 ? list[`${item}单`].push(code) : list[`${item}双`].push(code)
                }
            }
            for (let item of ['大', '小']) {
                for (let code of list[item]) {
                    code % 2 == 1 ? list[`${item}单`].push(code) : list[`${item}双`].push(code)
                }
            }
            for (let item of list['走兽']) {
                list['野兽'].push(item)
            }

            list['金'] = this.otherCode('金');
            list['木'] = this.otherCode('木');
            list['水'] = this.otherCode('水');
            list['火'] = this.otherCode('火');
            list['土'] = this.otherCode('土');
            list['阴肖'] = this.otherCode('阴肖');
            list['阳肖'] = this.otherCode('阳肖');
            list['天肖'] = this.otherCode('天肖');
            list['地肖'] = this.otherCode('地肖');
            list['女肖'] = this.otherCode('女肖');
            list['男肖'] = this.otherCode('男肖');
            list['单笔'] = this.otherCode('单笔');
            list['双笔'] = this.otherCode('双笔');
            return list
        }
    },
    methods: {

        // 球号数据
        CodeInfo(code) {
            let color = this.CodeColor(code)
            let zodiac = this.CodeZodiac(code)
            return {
                color, zodiac,
                size: code >= 25 ? 'big' : 'small',
                parity: code % 2 == 1 ? 'odd' : 'even'
            }
        },
        // 计算号码颜色 & 返回所有号码颜色列表
        CodeColor(code) {
            if (code && typeof code === 'string') {
                if (code[0]==='红') {return 'red'}
                if (code[0]==='蓝') {return 'blue'}
                if (code[0]==='绿') {return 'green'}
            }
            let dir = {}
            for (let pack of [{key: 'lhc_red_wave', val: 'red'}, {key: 'lhc_blue_wave', val: 'blue'}, {key: 'lhc_green_wave', val: 'green'}]) {
                for (let item of this.Base[pack.key].split(',')) {
                    dir[item] = pack.val
                }
            }
            return code ? dir[code] : dir
        },
        CodeColorGroup() {
            let obj = {}
            let list = this.CodeColor()
            for (let code in list) {
                if (!obj[list[code]]) {
                    obj[list[code]] = []
                }
                obj[list[code]].push(code)
            }
            return obj
        },
        // 计算号码生肖 & 返回所有号码生肖列表
        CodeZodiac(code) {
            let rule = this.ZodiacList
            if (code) {
                let num = parseInt(code)
                try {
                    return rule[num%12] || rule[12]
                } catch (err) {
                    return null
                }
            } else {
                let obj = {}
                for (let code=1;code<=49;code++) {
                    obj[code] = rule[code%12] || rule[12]
                }
                return obj
            }
        },
        otherCode(code) {
            const mouse = this.$store.state.base.options.lhc_mouse.split(',').map(Number);//lhc_mouse
            const cattle = this.$store.state.base.options.lhc_cattle.split(',').map(Number);//lhc_cattle
            const tiger = this.$store.state.base.options.lhc_tiger.split(',').map(Number);
            const rabbit = this.$store.state.base.options.lhc_rabbit.split(',').map(Number);
            const dragon = this.$store.state.base.options.lhc_dragon.split(',').map(Number);
            const snake = this.$store.state.base.options.lhc_snake.split(',').map(Number);
            const horse = this.$store.state.base.options.lhc_horse.split(',').map(Number);
            const sheep = this.$store.state.base.options.lhc_sheep.split(',').map(Number);
            const monkey = this.$store.state.base.options.lhc_monkey.split(',').map(Number);
            const chicken = this.$store.state.base.options.lhc_chicken.split(',').map(Number);
            const dog = this.$store.state.base.options.lhc_dog.split(',').map(Number);
            const pig = this.$store.state.base.options.lhc_pig.split(',').map(Number);
            if(code == '金'){
                return this.$store.state.base.options.jin_zodiac.split(',').map(Number);
            }
            else if(code == '木'){
                return this.$store.state.base.options.mu_zodiac.split(',').map(Number);
            }
            else if(code == '水'){
                return this.$store.state.base.options.shui_zodiac.split(',').map(Number);
            }
            else if(code == '火'){
                return this.$store.state.base.options.huo_zodiac.split(',').map(Number);
            }
            else if(code == '土'){
                return this.$store.state.base.options.tu_zodiac.split(',').map(Number);
            }
            else if(code == '阴肖'){
                return [...mouse,...dragon,...snake,...horse,...dog,...pig];
            }
            else if(code == '阳肖'){
                return [...cattle,...tiger,...rabbit,...sheep,...monkey,...chicken];
            }
            else if(code == '天肖'){
                return [...rabbit,...horse,...monkey,...pig,...cattle,...dragon];
            }
            else if(code == '地肖'){
                return [...snake,...sheep,...chicken,...dog,...mouse,...tiger];
            }
            else if(code == '女肖'){
                return [...rabbit,...snake,...sheep,...chicken,...pig];
            }
            else if(code == '男肖'){
                return [...mouse,...cattle,...tiger,...dragon,...horse,...monkey,...dog];
            }
            else if(code == '单笔'){
                return [...mouse,...dragon,...horse,...snake,...chicken,...pig];
            }
            else if(code == '双笔'){
                return [...tiger,...monkey,...dog,...rabbit,...sheep,...cattle];
            }
        },
        isBingoGame(gamesId) {
            const id = gamesId != null ? gamesId : (this.Filter && this.Filter.games_id)
            return Number(id) === 36
        },
        isBingoNoResult(item) {
            if (!item) return false
            const gamesId = item.games_id != null ? item.games_id : (this.Filter && this.Filter.games_id)
            if (Number(gamesId) !== 36) return false
            if (item._noResult) return true
            if (Number(item.status) === 1 && item.data && String(item.data).trim()) return false
            if (item.data && String(item.data).trim()) return false
            if (item.end_time) {
                return new Date(String(item.end_time).replace(/-/g, '/')) < new Date()
            }
            return Number(item.status) !== 1
        },
        fillBingoMissingPeriods(list) {
            if (!list || list.length < 2 || !this.isBingoGame()) return list || []
            const out = []
            for (let i = 0; i < list.length; i++) {
                out.push(list[i])
                if (i >= list.length - 1) continue
                const curr = Number(list[i].number)
                const next = Number(list[i + 1].number)
                if (!curr || !next || curr - next <= 1) continue
                for (let n = curr - 1; n > next; n--) {
                    out.push({
                        id: `bingo-missing-${n}`,
                        number: n,
                        games_id: 36,
                        status: 0,
                        data: '',
                        _noResult: true,
                        week: '-',
                        date: '-',
                    })
                }
            }
            return out
        },
        bingoDisplayList(list) {
            const source = list || []
            if (!this.isBingoGame()) return source
            return this.fillBingoMissingPeriods(source)
        },
    },
    mounted() {

    }
}